<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/pc_banner_sup_faq_k.webp')">
      <div class="content pos-relative">
        <go-to-top />
        <div id="anchor1" class="section">
          <h1 class="main-title">
            Jack Rabbit Apex Q＆A一覧
          </h1>

          <ul class="list-type-Q">
            <li>
              <b class="fw_bold">Jack Rabbit Apexへの登録方法はどうすればいいですか？ </b>
              <p>「新規登録」をクリックし、必要事項を記入したら、登録完了となります。 </p>
            </li>

            <li>
              <b class="fw_bold">どのようなデバイスでプレイできますか？ </b>
              <p>
                Jack Rabbit Apexは、すべての主要なモバイルデバイスおよびパソコンに対応しており、いつでもどこでもお楽しみいただけます。
              </p>
            </li>

            <li>
              <b class="fw_bold">年齢制限はありますか？ </b>
              <p>Jack Rabbit Apexのご利用は、21歳以上の方に限定しております。 </p>
            </li>

            <li>
              <b class="fw_bold">プレイ可能な地域はどこですか？ </b>
              <p>
                以下の国または地域にお住まいのお客様は、 Jack Rabbit Apex の口座開設、およびご利用はできません。 <br>
                オーストラリア、オーストリア、コモロ諸島、フランス、ドイツ、オランダ、スペイン、英国、米国、すべてのFATFブラックリスト掲載国、他違法とされている国。
              </p>
            </li>

            <li>
              <b class="fw_bold">カジノで使用できる通貨は何ですか？</b>
              <p>Jack Rabbit ApexはUSDを採用しており、仮想通貨USDT（TRC20）の入出金に対応しております。</p>
            </li>

            <li>
              <b class="fw_bold">アカウントは一人でいくつまで作成できますか？</b>
              <p>
                当サイトでは、お一人様につき1アカウントのみ作成・利用が可能です。<br>
                すべてのお客様に公平なゲーム環境をご提供するため、 複数のアカウントを作成・利用する行為は禁止されています。<br>
                具体的には、
              </p>
              <ol class="list-type-disc">
                <li>1人につき1アカウント</li>
                <li>1世帯につき1アカウント</li>
              </ol>
              <p>
                までとさせていただいております。<br>
                これらのルールに違反した場合、Jack Rabbit Apex は 該当アカウントの利用停止、すべてのキャンペーン参加資格の取り消し、およびウォレット内残高の没収 を行う権利を有しています。
              </p>
            </li>

            <li>
              <b class="fw_bold">自宅以外のコンピューターで利用することはできますか？</b>
              <p>
                はい、ご利用いただけます。<br>
                ただし、自宅以外のコンピューター(公共のPCや他人の端末など)をご利用の際は、アカウント情報の管理に十分ご注意ください。<br>
                第三者による不正利用を防ぐため、ログイン情報の保存をしない、利用後は必ずログアウトするなど、ご自身でのセキュリティ管理をお願いいたします。 <br>
                なお、お客様のアカウントが第三者に不正使用されたことによって生じた損害について、Jack Rabbit Apex は一切の責任を負いかねますので、あらかじめご了承ください。
              </p>
            </li>

            <li>
              <b class="fw_bold">VPNを使用してプレイできますか？</b>
              <p>Jack Rabbit Apexでは、VPNやプロキシサーバーなどで実際の利用所在地を隠すことを禁止しております。 </p>
            </li>

            <li>
              <b class="fw_bold">ログインできません。どうすれば良いですか？</b>
              <p>
                ユーザー名またはパスワードが正しいかをご確認ください。<br>
                それでも解決しない場合は、カスタマーサポートまでお問い合わせください。
              </p>
            </li>

            <li>
              <b class="fw_bold">メールアドレスはどのように変更できますか？</b>
              <p>メールアドレスの変更はできません。</p>
            </li>

            <li>
              <b class="fw_bold">ユーザー名を変更できますか？</b>
              <p>いいえ、アカウント登録後にユーザー（アカウント名）を変更することはできません。</p>
            </li>

            <li>
              <b class="fw_bold">パスワードは変更できますか？</b>
              <p>ログイン後、「アカウント認証」ページにある「パスワード設定」よりご変更ができます。</p>
            </li>

            <li>
              <b class="fw_bold">パスワードを忘れた場合、どうすれば良いですか？</b>
              <p>ログイン画面にある「パスワードをお忘れの場合」からユーザー名とメールアドレスを入力し、再設定ができます。 </p>
            </li>

            <li>
              <b class="fw_bold">アカウント名を忘れた場合、どうすれば良いですか？</b>
              <p>
                お忘れになったアカウントに関する情報は、「メールアドレス」を明記の上、Telegramまたはメールにてご連絡ください。<br>
                入力されたメールアドレスに紐づくアカウント情報を確認後、該当するアカウント名を通知いたします。
              </p>
            </li>

            <li>
              <b class="fw_bold">メール配信の停止はできますか？</b>
              <p>
                はい、メール配信の停止は可能です。 <br>
                キャンペーンメールの最下部に記載されている 「配信停止はこちら」 から、配信停止のお手続きを行ってください。<br>
                また、配信停止リンクから手続きができない場合は、お問い合わせフォームまたはサポート窓口までご連絡ください。<br>
                その際、以下の情報をお知らせください。
              </p>
              <ol class="list-type-disc">
                <li>ユーザー名 </li>
                <li>メール配信の停止を希望する旨 </li>
                <li>ご登録のメールアドレス</li>
              </ol>
              <p>内容を確認のうえ、ご本人による申請であることを確認でき次第、メール配信停止の手続きを行います。</p>
            </li>

            <li>
              <b class="fw_bold">退会や、アカウントの削除はできますか？</b>
              <p>
                データベース上からアカウント情報を完全に削除することはできません。<br>
                その代わり、アカウントの凍結（利用停止）をすることができます。<br>
                なお、アカウントを凍結した後でも、当サイトの判断により、再度新しいアカウントを登録できる場合があります。<br>
                ただし、以前使用していたユーザー名（アカウント名）を再利用することはできません。
              </p>
            </li>

            <li>
              <b class="fw_bold">カスタマーサポートにはいつ問い合わせできますか？</b>
              <p>Jack Rabbit Apexでは、完全に日本語対応しており、 Telegramまたはメールにて24時間365日サポートをご提供しています。</p>
            </li>

            <li>
              <b class="fw_bold">どのような入金方法がありますか？</b>
              <p>Jack Rabbit Apexでは仮想通貨による入金をご利用いただけます。</p>
            </li>

            <li>
              <b class="fw_bold">1回あたりの入金可能額はいくらですか？</b>
              <p>最低入金額は 10USDT ～、入金額の上限はございません。</p>
            </li>

            <li>
              <b class="fw_bold">入金の際に、手数料は必要ですか？</b>
              <p>
                入金の際の手数料は無料です。<br>
                ただし、ブロックチェーンネットワーク上で発生する送金手数料（ネットワーク手数料）は、ユーザー様のご負担となります。
              </p>
            </li>

            <li>
              <b class="fw_bold">入金にかかる時間はどれくらいですか？</b>
              <p>通常は5～30分ほどで完了いたします。</p>
            </li>

            <li>
              <b class="fw_bold">入金時間に制限はありますか？</b>
              <p>
                入金は、24時間いつでもご利用いただけます。<br>
                ただし、決済ルート（チャネル）のメンテナンスが行われる場合は、事前にお知らせいたします。<br>
                なお、決済ルートが閉鎖または一時停止されている期間中は、入金および出金の両方が一時的にご利用いただけません。 あらかじめご了承ください。
              </p>
            </li>

            <li>
              <b class="fw_bold">入金後すぐに出金できますか？</b>
              <p>
                マネーロンダリング等の不正送金を防止するため、入金直後の出金はできません。<br>
                ゲームの結果に関わらず、お客様は入金額の「2倍」をベットする必要がございます。<br>
                この条件を満たした上で出金することが可能です。
              </p>
            </li>

            <li>
              <b class="fw_bold">どのような出金方法がありますか？</b>
              <p>Jack Rabbit Apexでは仮想通貨による出金方法をご提供しております。</p>
            </li>

            <li>
              <b class="fw_bold">1回あたりの出金可能額はいくらですか？</b>
              <p>各ランクに応じて設定された1日あたりの出金上限までとなります。</p>
            </li>

            <li>
              <b class="fw_bold">1日の最大出金可能額はありますか？</b>
              <p>各ランクに応じて設定された1日の最大出金可能額がございます。</p>
              <div class="table-wrap">
                <table class="rank-table">
                  <thead>
                    <tr>
                      <th>ランク名</th>
                      <th>最大出金可能額</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                      <td>{{ row.rank }}</td>
                      <td>{{ row.amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>

            <li>
              <b class="fw_bold">出金の際に、手数料は必要ですか？</b>
              <p>
                出金の際の手数料は無料です。<br>
                ただし、ブロックチェーンネットワーク上で発生する送金手数料（ネットワーク手数料）は、ユーザー様のご負担となります。
              </p>
            </li>

            <li>
              <b class="fw_bold">出金にかかる時間はどれくらいですか？</b>
              <p>出金申請を受け付け次第、内容確認のうえ順次対応いたします。</p>
            </li>

            <li>
              <b class="fw_bold">出金する際に、身分証明書を提出する必要がありますか？</b>
              <p>
                原則として、身分証明書のご提出は必要ありません。<br>
                ただし、不正防止やセキュリティ上の理由により、追加の確認をお願いする場合があります。
              </p>
            </li>

            <li>
              <b class="fw_bold">出金時間に制限はありますか？</b>
              <p>ございません。Jack Rabbit Apexでは365日、24時間出金サービスをご提供しております。</p>
            </li>

            <li>
              <b class="fw_bold">USDTとは何ですか？</b>
              <p>
                USDTは、ステーブルコインと呼ばれる暗号通貨の一種です。<br>
                USDTの価値は米ドルと連動しており、1USDT は常に 1USD相当の価値を持つように設計されています。<br>
                価格変動が大きい他の暗号通貨と比べて、価値が安定していることが特徴で、入金や決済に安心して利用できる通貨です。
              </p>
            </li>

            <li>
              <b class="fw_bold">なぜTRC20（TRON）ネットワークのみを採用しているのですか？</b>
              <p>
                当サービスでは、仮想通貨の送金ネットワークとして TRC20（TRON） のみを採用しています。<br>
                これは、以下の理由によるものです。
                <ol class="list-type-disc">
                  <li>送金手数料が安く、利用者の負担が少ないため</li>
                  <li>送金スピードが速く、入金反映がスムーズなため</li>
                  <li>ご誤ったネットワークでの送金によるトラブルを防ぐため</li>
                </ol>
                対応ネットワークをTRC20に限定することで、安全かつ分かりやすい入出金環境をご提供しています。
              </p>
            </li>

            <li>
              <b class="fw_bold">どのようなカジノゲームがありますか？</b>
              <p>
                Jack Rabbit Apexは、世界トップクラスのオンラインカジノゲームプロバイダーを厳選しており、海外へ渡航することなく、世界各地のカジノゲームをお楽しみいただけます。<br>
                バカラ、ブラックジャック、ルーレットなどのクラシックなカジノゲームをはじめとした約6,000種類以上のカジノゲームやスロットをお楽しみいただけます。
              </p>
            </li>

            <li>
              <b class="fw_bold">オンラインライブ&テーブルの利点は何ですか？</b>
              <p>
                オンラインライブ＆テーブルゲームでは、コンピューターによる乱数制御ではなく、実際のライブディーラーがゲームを進行します。<br>
                そのため、ゲームの公正性・透明性・信頼性が高く、HDビデオストリーミングを通じて、まるで本物のカジノにいるかのような臨場感あるプレイをお楽しみいただけます。<br>
                バカラ、ルーレット、ブラックジャックなどの定番カジノゲームを豊富にご用意しており、時間や場所を問わず、24時間いつでもご自宅で本格的なカジノ体験が可能です。
              </p>
            </li>

            <li>
              <b class="fw_bold">ゲームの公平性は保たれていますか？</b>
              <p>
                はい。Jack Rabbit Apex では、すべてのゲームにおいて公平性が保たれるよう厳格に管理されています。<br>
                ライブゲームでは、専門的な訓練と教育を受けたディーラーのみがゲームを進行しており、すべてのゲーム結果はゲームプロバイダーによって常時監視されています。<br>
                また、スロットやテーブルゲームなどのデジタルゲームでは、<br>
                乱数発生装置(RNG)を使用して結果が生成されており、人為的な操作が行われない仕組みとなっています。<br>
                これにより、すべてのプレイヤーが公正で信頼性の高い環境でゲームをお楽しみいただけます。
              </p>
            </li>

            <li>
              <b class="fw_bold">各ゲームの最低ベット額はいくらですか？</b>
              <p>各ゲームによって異なるため、ゲーム内の最低ベット額をご確認ください。</p>
            </li>

            <li>
              <b class="fw_bold">ゲームのプレイ記録はどのように確認できますか？</b>
              <p>アカウント内にある「ゲーム履歴」からご確認いただけます。</p>
            </li>

            <li>
              <b class="fw_bold">ボーナス利用中のベット上限はありますか？</b>
              <p>
                現在のシステム仕様では、当プラットフォーム側でのベット金額の上限は設けておりません。<br>
                ただし、ゲームプロバイダーの仕様により制限が設けられる場合があります。
              </p>
            </li>

            <li>
              <b class="fw_bold">【ボーナスウォレット】を使用した場合のベット額の上限はありますか？</b>
              <p>
                現在のシステム仕様では、当プラットフォーム側でのベット額の上限は設けておりません。<br>
                ただし、ゲームプロバイダーの仕様により制限が設けられる場合があります。
              </p>
            </li>

            <li>
              <b class="fw_bold">KYC（本人確認）は必要ですか？</b>
              <p>原則必要ありません。</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
export default {
  name: 'FaqPurple',
  components: {
    goToTop
  },
  data() {
    return {
      rows: [
        { rank: 'Rookie', amount: '$500' },
        { rank: 'Challenger', amount: '$500' },
        { rank: 'Pro', amount: '$1,000' },
        { rank: 'Elite', amount: '$5,000' },
        { rank: 'Legend', amount: '$10,000' },
        { rank: 'GIII Silver', amount: '$10,000' },
        { rank: 'GIII Gold', amount: '$100,000' },
        { rank: 'GIII Elite', amount: '$100,000' },
        { rank: 'GII Silver', amount: '$100,000' },
        { rank: 'GII Gold', amount: '無制限' },
        { rank: 'GII Elite', amount: '無制限' },
        { rank: 'GI Silver', amount: '無制限' },
        { rank: 'GI Gold', amount: '無制限' },
        { rank: 'GI Elite', amount: '無制限' },
        { rank: 'God of Apex', amount: '無制限' }
      ]
    }
  },
  computed: {
    supportEmail() {
      return process.env.VUE_APP_SUPPORT_EMAIL
    }
  },
  created() {
  },
  methods: {
    scrollTo(id) {
      setTimeout(() => {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 10)
    }
  }
}
</script>
<style>
.table-wrap {
  padding: 5px;
}

.rank-table {
  width: 100%;
  border-collapse: collapse;
  color: #000000;
  font-size: 14px;
}
/* 表頭 */
.rank-table thead th {
  font-weight: bold;
  text-align: left;
  padding: 10px 10px;
  border: 1px solid #444;
}

/* 表身 */
.rank-table tbody td {
  padding: 10px 10px;
  border: 1px solid #444;
}
</style>
